import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import { getTokenFromStorage } from '@/utils/auth';
import { getTeamsSearch } from '@/api/beatlyApi';

/**
 * Fetches teams the current client user belongs to (GET /app/v2/teams/search).
 */
export function useTeamsSearch() {
  const { user } = useAuth();
  const token = getTokenFromStorage();
  const enabled = Boolean(token && user?.is_client);

  return useQuery({
    queryKey: ['client', 'teams', 'search'],
    queryFn: async () => getTeamsSearch(token!),
    enabled,
  });
}
